import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { renderErrorMessage } from "Services/LoggingService";

import { getIVRList, type IVRQueryResult } from "../queries";

import type { QueryParams } from "@regal-voice/ui";

type HookProps = {
    queryParams: Partial<QueryParams>;
};

export function useIVRListData({ queryParams }: HookProps) {
    const { loading, data } = useQuery<IVRQueryResult>(getIVRList, {
        variables: {
            queryParams,
        },
        fetchPolicy: "cache-and-network",
        onError: (error) => {
            renderErrorMessage({
                content: "Failed to retrieve IVRs.",
                error,
            });
        },
    });

    const listItems = useMemo(() => data?.getIvrFlows.items ?? [], [data]);
    const totalItems = data?.getIvrFlows?.total ?? 0;

    return { loading, items: listItems, totalItems };
}
